var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M34.1213 22.1214L29.8787 17.8788C29.6222 17.6222 29.324 17.417 29 17.2695V21.4001C29 21.9601 29 22.2401 29.109 22.4541C29.2049 22.6422 29.3578 22.7952 29.546 22.8911C29.7599 23.0001 30.0399 23.0001 30.6 23.0001H34.7305C34.5831 22.6761 34.3778 22.3779 34.1213 22.1214Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 17.2695V21.4001C29 21.9601 29 22.2401 29.109 22.4541C29.2049 22.6422 29.3578 22.7952 29.546 22.8911C29.7599 23.0001 30.0399 23.0001 30.6 23.0001H34.7305M24.5 27L29.5 32M29.5 27L24.5 32M29 17H23.8C22.1198 17 21.2798 17 20.638 17.327C20.0735 17.6146 19.6146 18.0735 19.327 18.638C19 19.2798 19 20.1198 19 21.8V32.2C19 33.8802 19 34.7202 19.327 35.362C19.6146 35.9265 20.0735 36.3854 20.638 36.673C21.2798 37 22.1198 37 23.8 37H30.2C31.8802 37 32.7202 37 33.362 36.673C33.9265 36.3854 34.3854 35.9265 34.673 35.362C35 34.7202 35 33.8802 35 32.2V23L29 17Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileX);
export default __webpack_public_path__ + "static/media/file-x.cb852d5b.svg";
export { ForwardRef as ReactComponent };